import { usePaginatedApi } from "../../../swr/useApi";
import { productService } from "../../api_client";
import type { ProductDto, SimilarProductsQueryDto } from "../../../api";

export function useSimilarProducts(query?: SimilarProductsQueryDto) {
    return usePaginatedApi<ProductDto, SimilarProductsQueryDto>({
        key: query?.productId ? "similar-products" : null,
        serviceMethod: async (queryParams) =>
            await productService.getSimilarProducts(queryParams),
        query: query,
    });
}
